import React, { useState, useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { Button } from '../../../components'
import { storyService } from '../services'
import { appName } from '../appConfig'
import config from '../../../config'
import '../index.css'

const StoryPreview = () => {
  const navigate = useNavigate()
  const { slug }  = useParams()
  const [story, setStory]     = useState(null)
  const [loading, setLoading] = useState(true)
  const [error, setError]     = useState(null)

  useEffect(() => {
    const ctrl = new AbortController()
    storyService.getBySlug(slug, ctrl.signal)
      .then(res => { setStory(res.story); setLoading(false) })
      .catch(err => { if (err.name !== 'AbortError') { setError('Kunde inte ladda storyn'); setLoading(false) } })
    return () => ctrl.abort()
  }, [slug])

  if (loading) return <div className="ks-page"><p style={{ color: 'var(--color-dark-grey)' }}>Laddar…</p></div>
  if (error)   return <div className="ks-page"><p style={{ color: 'var(--color-intense-red)' }}>{error}</p></div>

  const topic   = story?.story_data?.topic || slug
  const uuid    = story?.story_uuid
  const htmlUrl = uuid ? `${config.api.url}/${appName}/story/${uuid}/html` : null

  return (
    <div className="ks-preview-page">
      <div className="ks-preview-header">
        <div className="ks-preview-header-inner">
          <Button value="Redigera" className="button" onClick={() => navigate(`/${appName}/${slug}/edit`)} />
        </div>
      </div>
      {htmlUrl
        ? <iframe className="ks-preview-frame" src={htmlUrl} title={`One-pager — ${topic}`} />
        : <div className="ks-page" style={{ paddingTop: 40 }}>
            <p style={{ color: 'var(--color-dark-grey)', fontStyle: 'italic' }}>
              Ingen one-pager genererad ännu.{' '}
              <Button value="Öppna editorn för att generera" className="button" onClick={() => navigate(`/${appName}/${slug}/edit`)} />
            </p>
          </div>
      }
    </div>
  )
}

export default StoryPreview
